
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "../components/layout/page";
import Head from "next/head";
export default function TermsOfService() {
    const { t } = useTranslation("common");
    return (<Page title={"Site Terms and Conditions of Use"} className="w-full max-w-none prose dark:prose-dark" padded>
      <Head>
        <title>Chess Hotel | Terms of service</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      {/* <div className="w-full max-w-none prose dark:prose-dark"> */}
      <h3>1. User's Acknowledgment and Acceptance of Terms</h3>
      <p>
        Foggy Media AB (&quot;Us&quot; or &quot;We&quot;) provides the Chess
        Hotel site, translations of the site and various related services
        (collectively, the &quot;site&quot;) to you, the user, subject to your
        compliance with all the terms, conditions, and notices contained or
        referenced herein (the &quot;Terms of Use&quot;), as well as any other
        written agreement between us and you. In addition, when using particular
        services or materials on this site, users shall be subject to any posted
        rules applicable to such services or materials that may contain terms
        and conditions in addition to those in these Terms of Use. All such
        guidelines or rules are hereby incorporated by reference into these
        Terms of Use.
      </p>
      <p>
        BY USING THIS SITE, YOU AGREE TO BE BOUND BY THESE TERMS OF USE. IF YOU
        DO NOT WISH TO BE BOUND BY THE THESE TERMS OF USE, PLEASE EXIT THE SITE
        NOW. YOUR REMEDY FOR DISSATISFACTION WITH THIS SITE, OR ANY PRODUCTS,
        SERVICES, CONTENT, OR OTHER INFORMATION AVAILABLE ON OR THROUGH THIS
        SITE, IS TO STOP USING THE SITE AND/OR THOSE PARTICULAR PRODUCTS OR
        SERVICES. YOUR AGREEMENT WITH US REGARDING COMPLIANCE WITH THESE TERMS
        OF USE BECOMES EFFECTIVE IMMEDIATELY UPON COMMENCEMENT OF YOUR USE OF
        THIS SITE.
      </p>
      <p>
        These Terms of Use are effective as of 2007-01-01. We expressly reserve
        the right to change these Terms of Use from time to time without notice
        to you. You acknowledge and agree that it is your responsibility to
        review this site and these Terms of Use from time to time and to
        familiarize yourself with any modifications. Your continued use of this
        site after such modifications will constitute acknowledgement of the
        modified Terms of Use and agreement to abide and be bound by the
        modified Terms of Use.
      </p>
      <p>
        As used in these Terms of Use, references to our &quot;Affiliates&quot;
        include our owners, subsidiaries, affiliated companies, officers,
        directors, suppliers, partners, sponsors, and advertisers, and includes
        (without limitation) all parties involved in creating, producing, and/or
        delivering this site and/or its contents.
      </p>
      <h3>2. Description of Services</h3>
      <p>
        We make various services available on this site including, but not
        limited to, Chess online, and other like services. You are responsible
        for providing, at your own expense, all equipment necessary to use the
        services, including a computer, modem, and Internet access (including
        payment of all fees associated with such access).
      </p>
      <p>
        We reserve the sole right to either modify or discontinue the site,
        including any of the sites features, at any time with or without notice
        to you. We will not be liable to you or any third party should we
        exercise such right. Any new features that augment or enhance the
        then-current services on this site shall also be subject to these Terms
        of Use.
      </p>
      <h3>3. Registration Data and Privacy</h3>
      <p>
        In order to access some of the services on this site, you will be
        required to use an account and password that can be obtained by
        completing our online registration form, which requests certain
        information and data (&quot;Registration Data&quot;), and maintaining
        and updating your Registration Data as required. By registering, you
        agree that all information provided in the Registration Data is true and
        accurate and that you will maintain and update this information as
        required in order to keep it current, complete, and accurate.
      </p>
      <p>
        You also grant us the right to disclose to third parties certain
        Registration Data about you. The information we obtain through your use
        of this site, including your Registration Data, is subject to our
        Privacy Policy, which is specifically incorporated by reference into
        these Terms of Use.
      </p>
      <h3>4. Conduct on Site</h3>
      <p>
        Your use of the site is subject to all applicable laws and regulations,
        and you are solely responsible for the substance of your communications
        through the site. By posting information in or otherwise using any
        communications service, chat room, message board, newsgroup, software
        library, or other interactive service that may be available to you on or
        through this site, you agree that you will not upload, share, post, or
        otherwise distribute or facilitate distribution of any content --
        including text, communications, software, images, sounds, data, or other
        information -- that:
      </p>
      <p>
        a. is unlawful, threatening, abusive, harassing, defamatory, libelous,
        deceptive, fraudulent, invasive of anothers privacy, tortious, contains
        explicit or graphic descriptions or accounts of sexual acts (including
        but not limited to sexual language of a violent or threatening nature
        directed at another individual or group of individuals), or otherwise
        violates our rules or policies;
      </p>
      <p>
        b. victimizes, harasses, degrades, or intimidates an individual or group
        of individuals on the basis of religion, gender, sexual orientation,
        race, ethnicity, age, or disability;
      </p>
      <p>
        c. infringes on any patent, trademark, trade secret, copyright, right of
        publicity, or other proprietary right of any party;
      </p>
      <p>
        d. constitutes unauthorized or unsolicited advertising, junk or bulk
        email (also known as &quot;spamming&quot;), chain letters, any other
        form of unauthorized solicitation, or any form of lottery or gambling;
      </p>
      <p>
        e. contains software viruses or any other computer code, files, or
        programs that are designed or intended to disrupt, damage, or limit the
        functioning of any software, hardware, or telecommunications equipment
        or to damage or obtain unauthorized access to any data or other
        information of any third party; or
      </p>
      <p>
        f. impersonates any person or entity, including any of our employees or
        representatives.
      </p>
      <p>
        We neither endorse nor assume any liability for the contents of any
        material uploaded or submitted by third party users of the site. We
        generally do not pre-screen, monitor, or edit the content posted by
        users of communications services, chat rooms, message boards,
        newsgroups, software libraries, or other interactive services that may
        be available on or through this site. However, we and our agents have
        the right at their sole discretion to remove any content that, in our
        judgment, does not comply with these Terms of Use and any other rules of
        user conduct for our site, or is otherwise harmful, objectionable, or
        inaccurate. We are not responsible for any failure or delay in removing
        such content. You hereby consent to such removal and waive any claim
        against us arising out of such removal of content. See &quot;Use of Your
        Materials&quot; below for a description of the procedures to be followed
        in the event that any party believes that content posted on this site
        infringes on any patent, trademark, trade secret, copyright, right of
        publicity, or other proprietary right of any party.
      </p>
      <p>
        In addition, you may not use your account to breach security of another
        account or attempt to gain unauthorized access to another network or
        server. Not all areas of the site may be available to you or other
        authorized users of the site. You shall not interfere with anyone elses
        use and enjoyment of the site or other similar services. Users who
        violate systems or network security may incur criminal or civil
        liability.
      </p>
      <p>
        You agree that we may at any time, and at our sole discretion, terminate
        your membership, account, or other affiliation with our site without
        prior notice to you for violating any of the above provisions. In
        addition, you acknowledge that we will cooperate fully with
        investigations of violations of systems or network security at other
        sites, including cooperating with law enforcement authorities in
        investigating suspected criminal violations.
      </p>
      <h3>5. Third Party Sites and Information</h3>
      <p>
        This site may link you to other sites on the Internet or otherwise
        include references to information, documents, software, materials and/or
        services provided by other parties. These sites may contain information
        or material that some people may find inappropriate or offensive. These
        other sites and parties are not under our control, and you acknowledge
        that we are not responsible for the accuracy, copyright compliance,
        legality, decency, or any other aspect of the content of such sites, nor
        are we responsible for errors or omissions in any references to other
        parties or their products and services. The inclusion of such a link or
        reference is provided merely as a convenience and does not imply
        endorsement of, or association with, the site or party by us, or any
        warranty of any kind, either express or implied.
      </p>
      <h3>6. Intellectual Property Information</h3>
      <p>Copyright (c) 2007-01-01 Foggy Media AB All Rights Reserved.</p>
      <p>
        For purposes of these Terms of Use, &quot;content&quot; is defined as
        any information, data, communications, software, photos, video,
        graphics, music, sounds, and other material and services that can be
        viewed by users on our site. This includes message boards, chat, and
        other original content.
      </p>
      <p>
        By accepting these Terms of Use, you acknowledge and agree that all
        content presented to you on this site is protected by copyrights,
        trademarks, service marks, patents or other proprietary rights and laws,
        and is the sole property of Foggy Media AB and/or its Affiliates. You
        are only permitted to use the content as expressly authorized by us or
        the specific content provider. Except for a single copy made for
        personal use only, you may not copy, reproduce, modify, republish,
        upload, post, transmit, or distribute any documents or information from
        this site in any form or by any means without prior written permission
        from us or the specific content provider, and you are solely responsible
        for obtaining permission before reusing any copyrighted material that is
        available on this site. Any unauthorized use of the materials appearing
        on this site may violate copyright, trademark and other applicable laws
        and could result in criminal or civil penalties.
      </p>
      <p>
        Neither we or our Affiliates warrant or represent that your use of
        materials displayed on, or obtained through, this site will not infringe
        the rights of third parties. See &quot;Users Materials&quot; below for a
        description of the procedures to be followed in the event that any party
        believes that content posted on this site infringes on any patent,
        trademark, trade secret, copyright, right of publicity, or other
        proprietary right of any party.
      </p>
      <p>
        The following are registered trademarks, trademarks or service marks of
        Foggy Media AB or its Affiliates: Chess Hotel. All custom graphics,
        icons, logos and service names are registered trademarks, trademarks or
        service marks of Foggy Media AB or its Affiliates. All other trademarks
        or service marks are property of their respective owners. Nothing in
        these Terms of Use grants you any right to use any trademark, service
        mark, logo, and/or the name of Foggy Media AB or its Affiliates.
      </p>
      <h3>7. Unauthorized Use of Materials</h3>
      <p>
        Subject to our Privacy Policy, any communication or material that you
        transmit to this site or to us, whether by electronic mail, post, or
        other means, for any reason, will be treated as non-confidential and
        non-proprietary. While you retain all rights in such communications or
        material, you grant us and our agents and affiliates a non-exclusive,
        paid-up, perpetual, and worldwide right to copy, distribute, display,
        perform, publish, translate, adapt, modify, and otherwise use such
        material for any purpose regardless of the form or medium (now known or
        not currently known) in which it is used.
      </p>
      <p>
        Please do not submit confidential or proprietary information to us
        unless we have mutually agreed in writing otherwise. We are also unable
        to accept your unsolicited ideas or proposals, so please do not submit
        them to us in any circumstance.
      </p>
      <p>
        We respect the intellectual property of others, and we ask you to do the
        same. If you or any user of this site believes its copyright, trademark
        or other property rights have been infringed by a posting on this site,
        you or the user should send notification to our Designated Agent (as
        identified below) immediately. To be effective, the notification must
        include:
      </p>
      <p>
        1. Identify in sufficient detail the copyrighted work that you believe
        has been infringed upon or other information sufficient to specify the
        copyrighted work being infringed).
      </p>
      <p>
        2. Identify the material that you claim is infringing the copyrighted
        work listed in item #1 above.
      </p>
      <p>
        3. Provide information reasonably sufficient to permit us to contact you
        (email address is preferred).
      </p>
      <p>
        4. Provide information, if possible, sufficient to permit us to notify
        the owner/administrator of the allegedly infringing webpage or other
        content (email address is preferred).
      </p>
      <p>
        5. Include the following statement: &quot;I have a good faith belief
        that use of the copyrighted materials described above as allegedly
        infringing is not authorized by the copyright owner, its agent, or the
        law.&quot;
      </p>
      <p>
        6. Include the following statement: &quot;I swear, under penalty of
        perjury, that the information in the notification is accurate and that I
        am the copyright owner or am authorized to act on behalf of the owner of
        an exclusive right that is allegedly infringed.&quot;
      </p>
      <p>7. Sign the paper.</p>
      <p>8. Send the written communication to the following email address:</p>
      <p>Designated Agent for Claimed Infringement:</p>
      <p>
        <a href="mailto:david@chesshotel.com">David Shore</a>
        <br />
        Foggy Media AB
        <br />
        Stockholm, Sweden
      </p>
      <p>
        You acknowledge and agree that upon receipt of a notice of a claim of
        copyright infringement, we may immediately remove the identified
        materials from our site without liability to you or any other party and
        that the claims of the complaining party and the party that originally
        posted the materials will be referred to the United States Copyright
        Office for adjudication as provided in the Digital Millennium Copyright
        Act.
      </p>
      <h3>8. Disclaimer of Warranties</h3>
      <p>
        ALL MATERIALS AND SERVICES ON THIS SITE ARE PROVIDED ON AN &quot;AS
        IS&quot; AND &quot;AS AVAILABLE&quot; BASIS WITHOUT WARRANTY OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR
        PURPOSE, OR THE WARRANTY OF NON-INFRINGEMENT. WITHOUT LIMITING THE
        FOREGOING, WE MAKE NO WARRANTY THAT (A) THE SERVICES AND MATERIALS WILL
        MEET YOUR REQUIREMENTS, (B) THE SERVICES AND MATERIALS WILL BE
        UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE, (C) THE RESULTS THAT MAY
        BE OBTAINED FROM THE USE OF THE SERVICES OR MATERIALS WILL BE EFFECTIVE,
        ACCURATE OR RELIABLE, OR (D) THE QUALITY OF ANY PRODUCTS, SERVICES, OR
        INFORMATION PURCHASED OR OBTAINED BY YOU FROM THE SITE FROM US OR OUR
        AFFILIATES WILL MEET YOUR EXPECTATIONS OR BE FREE FROM MISTAKES, ERRORS
        OR DEFECTS.
      </p>
      <p>
        THIS SITE COULD INCLUDE TECHNICAL OR OTHER MISTAKES, INACCURACIES OR
        TYPOGRAPHICAL ERRORS. WE MAY MAKE CHANGES TO THE MATERIALS AND SERVICES
        AT THIS SITE, INCLUDING THE PRICES AND DESCRIPTIONS OF ANY PRODUCTS
        LISTED HEREIN, AT ANY TIME WITHOUT NOTICE. THE MATERIALS OR SERVICES AT
        THIS SITE MAY BE OUT OF DATE, AND WE MAKE NO COMMITMENT TO UPDATE SUCH
        MATERIALS OR SERVICES.
      </p>
      <p>
        THE USE OF THE SERVICES OR THE DOWNLOADING OR OTHER ACQUISITION OF ANY
        MATERIALS THROUGH THIS SITE IS DONE AT YOUR OWN DISCRETION AND RISK AND
        WITH YOUR AGREEMENT THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE
        TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM SUCH
        ACTIVITIES.
      </p>
      <p>
        Through your use of the site, you may have the opportunities to engage
        in commercial transactions with other users and vendors. You acknowledge
        that all transactions relating to any merchandise or services offered by
        any party, including, but not limited to the purchase terms, payment
        terms, warranties, guarantees, maintenance and delivery terms relating
        to such transactions, are agreed to solely between the seller or
        purchaser of such merchandize and services and you. WE MAKE NO WARRANTY
        REGARDING ANY TRANSACTIONS EXECUTED THROUGH, OR IN CONNECTION WITH THIS
        SITE, AND YOU UNDERSTAND AND AGREE THAT SUCH TRANSACTIONS ARE CONDUCTED
        ENTIRELY AT YOUR OWN RISK. ANY WARRANTY THAT IS PROVIDED IN CONNECTION
        WITH ANY PRODUCTS, SERVICES, MATERIALS, OR INFORMATION AVAILABLE ON OR
        THROUGH THIS SITE FROM A THIRD PARTY IS PROVIDED SOLELY BY SUCH THIRD
        PARTY, AND NOT BY US OR ANY OTHER OF OUR AFFILIATES.
      </p>
      <p>
        Content available through this site often represents the opinions and
        judgments of an information provider, site user, or other person or
        entity not connected with us. We do not endorse, nor are we responsible
        for the accuracy or reliability of, any opinion, advice, or statement
        made by anyone other than an authorized Foggy Media AB spokesperson
        speaking in his/her official capacity. Please refer to the specific
        editorial policies posted on various sections of this site for further
        information, which policies are incorporated by reference into these
        Terms of Use.
      </p>
      <p>
        You understand and agree that temporary interruptions of the services
        available through this site may occur as normal events. You further
        understand and agree that we have no control over third party networks
        you may access in the course of the use of this site, and therefore,
        delays and disruption of other network transmissions are completely
        beyond our control.
      </p>
      <p>
        You understand and agree that the services available on this site are
        provided &quot;AS IS&quot; and that we assume no responsibility for the
        timeliness, deletion, mis-delivery or failure to store any user
        communications or personalization settings.
      </p>
      <p>
        SOME STATES OR JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN
        WARRANTIES, SO SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.
      </p>
      <h3>9. Limitation of Liability</h3>
      <p>
        IN NO EVENT SHALL WE OR OUR AFFILIATES BE LIABLE TO YOU OR ANY THIRD
        PARTY FOR ANY SPECIAL, PUNITIVE, INCIDENTAL, INDIRECT OR CONSEQUENTIAL
        DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER, INCLUDING, WITHOUT
        LIMITATION, THOSE RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER
        OR NOT WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND ON
        ANY THEORY OF LIABILITY, ARISING OUT OF OR IN CONNECTION WITH THE USE OF
        THIS SITE OR OF ANY WEB SITE REFERENCED OR LINKED TO FROM THIS SITE.
      </p>
      <p>
        FURTHER, WE SHALL NOT BE LIABLE IN ANY WAY FOR THIRD PARTY GOODS AND
        SERVICES OFFERED THROUGH THIS SITE OR FOR ASSISTANCE IN CONDUCTING
        COMMERCIAL TRANSACTIONS THROUGH THIS SITE, INCLUDING WITHOUT LIMITATION
        THE PROCESSING OF ORDERS.
      </p>
      <p>
        SOME JURISDICTIONS PROHIBIT THE EXCLUSION OR LIMITATION OF LIABILITY FOR
        CONSEQUENTIAL OR INCIDENTAL DAMAGES, SO THE ABOVE LIMITATIONS MAY NOT
        APPLY TO YOU.
      </p>
      <h3>10. Indemnification</h3>
      <p>
        Upon a request by us, you agree to defend, indemnify, and hold us and
        our Affiliates harmless from all liabilities, claims, and expenses,
        including attorneys fees, that arise from your use or misuse of this
        site. We reserve the right, at our own expense, to assume the exclusive
        defense and control of any matter otherwise subject to indemnification
        by you, in which event you will cooperate with us in asserting any
        available defenses.
      </p>
      <h3>11. Security and Password</h3>
      <p>
        You are solely responsible for maintaining the confidentiality of your
        password and account and for any and all statements made and acts or
        omissions that occur through the use of your password and account.
        Therefore, you must take steps to ensure that others do not gain access
        to your password and account. Our personnel will never ask you for your
        password. You may not transfer or share your account with anyone, and we
        reserve the right to immediately terminate your account if you do
        transfer or share your account.
      </p>
      <h3>12. Participation in Promotions</h3>
      <p>
        From time to time, this site may include advertisements offered by third
        parties. You may enter into daily with or participate in promotions of
        the advertisers showing their products on this site. Any such daily or
        promotions, including the delivery of and the payment for goods and
        services, and any other terms, conditions, warranties or representations
        associated with such daily or promotions, are solely between you and the
        advertiser. We assume no liability, obligation or responsibility for any
        part of any such daily or promotion.
      </p>
      <h3>13. E-mail, Messaging, Blogging, and Chat Services</h3>
      <p>
        We may make email, messaging, blogging, or chat services (collectively,
        &quot;Communications&quot;) available to users of our site, either
        directly or through a third-party provider. We make available separate
        supplemental agreements characterizing the relationship between you and
        us that, except where expressly noted or contradictory, includes these
        Terms.
      </p>
      <p>
        We will not inspect or disclose the contents of private Communications
        except with the consent of the sender or the recipient, or in the
        narrowly-defined situations provided under the Electronic Communications
        Privacy Act, or as other required by law or by court or governmental
        order. Further information is available in our Privacy Policy.
      </p>
      <p>
        We may employ automated monitoring devices or techniques to protect our
        users from mass unsolicited communications (also known as
        &quot;spam&quot;) and/or other types of electronic communications that
        we deem inconsistent with our business purposes. However, such devices
        or techniques are not perfect, and we will not be responsible for any
        legitimate communication that is blocked, or for any unsolicited
        communication that is not blocked.
      </p>
      <p>
        Mailboxes may have a limited storage capacity. If you exceed the maximum
        permitted storage space, we may employ automated devices that delete or
        block email messages that exceed the limit. We will not be responsible
        for such deleted or blocked messages.
      </p>
      <h3>14. International Use</h3>
      <p>
        Although this site may be accessible worldwide, we make no
        representation that materials on this site are appropriate or available
        for use in locations outside Sweden, and accessing them from territories
        where their contents are illegal is prohibited. Those who choose to
        access this site from other locations do so on their own initiative and
        are responsible for compliance with local laws. Any offer for any
        product, service, and/or information made in connection with this site
        is void where prohibited.
      </p>
      <h3>15. Termination of Use</h3>
      <p>
        You agree that we may, in our sole discretion, terminate or suspend your
        access to all or part of the site with or without notice and for any
        reason, including, without limitation, breach of these Terms of Use. Any
        suspected fraudulent, abusive or illegal activity may be grounds for
        terminating your relationship and may be referred to appropriate law
        enforcement authorities.
      </p>
      <p>
        Upon termination or suspension, regardless of the reasons therefore,
        your right to use the services available on this site immediately
        ceases, and you acknowledge and agree that we may immediately deactivate
        or delete your account and all related information and files in your
        account and/or bar any further access to such files or this site. We
        shall not be liable to you or any third party for any claims or damages
        arising out of any termination or suspension or any other actions taken
        by us in connection with such termination or suspension.
      </p>
      <h3>16. Governing Law</h3>
      <p>
        This site (excluding any linked sites) is controlled by us from our
        offices within Stockholm, Sweden. It can be accessed from all countries
        around the world. As each of these places has laws that may differ from
        those of Stockholm, Sweden, by accessing this site both of us agree that
        the statutes and laws of the State of Stockholm, Sweden, without regard
        to the conflicts of laws principles thereof and the United Nations
        Convention on the International Sales of Goods, will apply to all
        matters relating to the use of this site and the purchase of products
        and services available through this site. Each of us agrees and hereby
        submits to the exclusive personal jurisdiction and venue any court of
        competent jurisdiction within the State of Stockholm, Sweden with
        respect to such matters.
      </p>
      <h3>17. Notices</h3>
      <p>
        All notices to a party shall be in writing and shall be made either via
        email or conventional mail. Notices to us must be sent to the attention
        of Customer Service at david@chesshotel.com, if by email, or at Foggy
        Media AB, Slåttervägen 8, Enskededalen, Stockholm, Sweden if by
        conventional mail. Notices to you may be sent to the address supplied by
        you as part of your Registration Data. In addition, we may broadcast
        notices or messages through the site to inform you of changes to the
        site or other matters of importance, and such broadcasts shall
        constitute notice to you at the time of sending.
      </p>
      <h3>18. Entire Agreement</h3>
      <p>
        These terms and conditions constitute the entire agreement and
        understanding between us concerning the subject matter of this agreement
        and supersedes all prior agreements and understandings of the parties
        with respect to that subject matter. These Terms of Use may not be
        altered, supplemented, or amended by the use of any other document(s).
        Any attempt to alter, supplement or amend this document or to enter an
        order for products or services which are subject to additional or
        altered terms and conditions shall be null and void, unless otherwise
        agreed to in a written agreement signed by you and us. To the extent
        that anything in or associated with this site is in conflict or
        inconsistent with these Terms of Use, these Terms of Use shall take
        precedence.
      </p>
      <h3>19. Miscellaneous</h3>
      <p>
        In any action to enforce these Terms of Use, the prevailing party will
        be entitled to costs and attorneys fees. Any cause of action brought by
        you against us or our Affiliates must be instituted with one year after
        the cause of action arises or be deemed forever waived and barred.
      </p>
      <p>
        You may not assign your rights and obligations under these Terms of Use
        to any party, and any purported attempt to do so will be null and void.
        We may free assign our rights and obligations under these Terms of Use.
      </p>
      <p>
        You agree not to sell, resell, reproduce, duplicate, copy or use for any
        commercial purposes any portion of this site, or use of or access to
        this site.
      </p>
      <p>
        In addition to any excuse provided by applicable law, we shall be
        excused from liability for non-delivery or delay in delivery of products
        and services available through our site arising from any event beyond
        our reasonable control, whether or not foreseeable by either party,
        including but not limited to, labor disturbance, war, fire, accident,
        adverse weather, inability to secure transportation, governmental act or
        regulation, and other causes or events beyond our reasonable control,
        whether or not similar to those which are enumerated above.
      </p>
      <p>
        If any part of these Terms of Use is held invalid or unenforceable, that
        portion shall be construed in a manner consistent with applicable law to
        reflect, as nearly as possible, the original intentions of the parties,
        and the remaining portions shall remain in full force and effect.
      </p>
      <p>
        Any failure by us to enforce or exercise any provision of these Terms of
        Use or related rights shall not constitute a waiver of that right or
        provision.
      </p>
      <h3>20. Contact Information</h3>
      <p>
        Excepas explicitly noted on this site, the services available through
        this site are offered by Foggy Media AB located at Slåttervägen 8,
        Enskededalen, Stockholm, Sweden. If you notice that any user is
        violating these Terms of Use, please contact us at david@chesshotel.com.
      </p>
      {/* </div> */}
    </Page>);
}

    async function __Next_Translate__getStaticProps__1a18c1f73f5__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/termsofservice',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a18c1f73f5__ as getStaticProps }
  